import React from 'react';
import { ResultsTableContent } from './ResultsTableContent';
import { Button } from '@/components/ui/button';
import { Download, Loader2 } from 'lucide-react';

interface GeneratedContent {
  title: string;
  description: string;
  altText: string;
  metaDescription: string;
  imageName: string;
}

interface ResultsTableProps {
  results: GeneratedContent[];
  onDownload: () => void;
  isGenerating?: boolean;
}

export const ResultsTable: React.FC<ResultsTableProps> = ({ 
  results, 
  onDownload,
  isGenerating = false 
}) => {
  if (results.length === 0 && !isGenerating) return null;

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-sage-800">
          {isGenerating ? 'Generating Content...' : 'Generated Results'}
        </h2>
        <Button
          onClick={onDownload}
          variant="outline"
          className="gap-2 button-animation"
          disabled={isGenerating}
        >
          <Download className="w-4 h-4" />
          Download CSV
        </Button>
      </div>

      {isGenerating ? (
        <div className="flex flex-col items-center justify-center py-12 space-y-4">
          <Loader2 className="w-8 h-8 animate-spin text-sage-600" />
          <p className="text-sage-600">Processing your images...</p>
        </div>
      ) : (
        <ResultsTableContent results={results} />
      )}
    </div>
  );
};